export { default } from './Stories';
export type { StoriesProps } from './Stories.types';
